import {
  Component,
  OnInit,
  OnDestroy,
  Inject,
  Output,
  EventEmitter,
  ViewChild,
} from "@angular/core";
import { Router, RouterOutlet, ActivationStart } from "@angular/router";
import { CurrentUserService } from "src/app/core/services/current-user.service";
import { Location } from "@angular/common";
import { MAT_DIALOG_DATA } from "@angular/material";
import { ModalService } from "src/app/shared/services/modal.service";
import { RedirctUrlService } from "src/app/shared/services/redirct-url.service";
import * as _ from "lodash";

@Component({
  selector: "app-add-customer-user",
  templateUrl: "./add-customer-user.component.html",
  styleUrls: ["./add-customer-user.component.scss"],
})
export class AddCustomerUserComponent implements OnInit, OnDestroy {
  @ViewChild(RouterOutlet, { static: false }) outlet: RouterOutlet;
  @Output() close = new EventEmitter();

  public notifications: any[] = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private currentUserService: CurrentUserService,
    private _redirectUrl: RedirctUrlService,
    private location: Location,
    private router: Router,
    public modal: ModalService
  ) {}

  currentUser: string;
  ngOnInit() {
    this.router.events.subscribe(e => {
      if (e instanceof ActivationStart) {
        this.outlet.deactivate();
      }
    });
    this.currentUserService.getUser().then(user => {
      this.currentUser = this.currentUserService.user.firstname;
    });
    //rendering Create component
    this.router.navigate([{
      outlets: { cust: ['create'] },
    }], {
        queryParams: {
          customerID: _.get(this.data, 'customerId', null),
          request: _.get(this.data, 'request', null),
          name: _.get(this.data, 'name', null),
          email: _.get(this.data, 'email', null),
          phone: _.get(this.data, 'phone', null),
          mobilePhone: _.get(this.data, 'mobilePhone', null),
          urlPath: _.get(this.data, 'urlPath', null)
        }
    });
  }

  onDeactivate() {
    document.body.scrollTop = 0;
  }

  public onRedirectHandler($event) {
    this._redirectUrl.onLogoutHandler($event);
  }

  public onBackEventHandler() {
    this.location.back();
  }

  onCancel() {
    this.modal.close();
    if(this.outlet && this.outlet.isActivated){
      this.outlet.deactivate();
    }
  }

  ngOnDestroy(){
    if(this.outlet && this.outlet.isActivated){
      this.outlet.deactivate();
    }
  }
}
